function xorHexStrings(a, b) {
  let result = "";

  for (let i = a.length - 1; i >= 0; i--) {
    result = (parseInt(a[i], 16) ^ parseInt(b[i], 16)).toString(16) + result;
  }

  return result;
}

function arrayBufferToBase64(arrayBuffer) {
  const uint8 = new Uint8Array(arrayBuffer);
  let stringToEncode = "";

  for (let i = 0, len = uint8.byteLength; i < len; i++) {
    stringToEncode += String.fromCharCode(uint8[i]);
  }

  return window.btoa(stringToEncode);
}

// See: https://developers.google.com/web/updates/2012/06/How-to-convert-ArrayBuffer-to-and-from-String
function strToArrayBuffer(str) {
  const arrayBuffer = new ArrayBuffer(str.length);
  const uint8 = new Uint8Array(arrayBuffer);

  for (let i = 0, len = str.length; i < len; i++) {
    uint8[i] = str.charCodeAt(i);
  }

  return arrayBuffer;
}

function hexToArrayBuffer(hex) {
  const result = new Uint8Array(hex.length / 2);

  for (let i = 0, k = 0, len = hex.length; i < len; i += 2, k += 1) {
    result[k] = parseInt(hex.substr(i, 2), 16);
  }

  return result;
}

// See: https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/importKey#SubjectPublicKeyInfo_import
function importRsaKey(publicKey) {
  const header = "-----BEGIN PUBLIC KEY-----";
  const footer = "-----END PUBLIC KEY-----";
  const content = publicKey.substring(
    header.length,
    publicKey.length - footer.length,
  );
  const decodedData = window.atob(content);
  const keyData = strToArrayBuffer(decodedData);

  return window.crypto.subtle.importKey(
    "spki",
    keyData,
    {
      name: "RSA-OAEP",
      hash: "SHA-256",
    },
    false,
    ["encrypt"],
  );
}

async function getEncodedPinBlock({ newPin, accountToken, publicKey }) {
  try {
    // See: https://di.latitudefinancial.com/wiki/pages/viewpage.action?spaceKey=EA&title=Pin+Change&preview=/77678397/77689549/1270A542-035%20Host%20Programmer%20v3.3.pdf
    // Page 173
    const firstBlock = `0${newPin.length}${newPin}`.padEnd(16, "F");
    const secondBlock = `0000${accountToken}`; // accountToken is expected to have 12 characters
    const pinBlock = xorHexStrings(firstBlock, secondBlock);
    const dataToEncrypt = hexToArrayBuffer(pinBlock);
    const cryptoKey = await importRsaKey(publicKey.trim());
    const arrayBuffer = await window.crypto.subtle.encrypt(
      { name: "RSA-OAEP" },
      cryptoKey,
      dataToEncrypt,
    );

    return arrayBufferToBase64(arrayBuffer);
  } catch (error) {
    console.error(error.message);
    return null;
  }
}

export { getEncodedPinBlock };
